module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"button.create_lot":"สร้าง Lot ใหม่","model_lots.not_valid":"ยังไม่สามารถสร้าง Lot ได้","model_lots.not_valid.description":"ควรกรอกข้อมูลอะไหล่ต่าง ๆ ให้เรียบร้อยก่อน จากนั้นปรับสถานะเป็นเริ่มนำไปใช้งาน เพื่อเพิ่มข้อมูล Lot ได้ (เพราะข้อมูลอะไหล่ ของ Model จะได้ตาม Lot ไปด้วย)"}}')
  delete Component.options._Ctor
}
